export const sortPointsByDistance = (targetPoint, pointsArray) => {
  const pointsDistance = pointsArray
    .map((item, index) => {
      const targetLat = targetPoint.coordinates[1]
      const targetLon = targetPoint.coordinates[0]

      const pointLat = item.coordinates[1]
      const pointLon = item.coordinates[0]

      return {
        point: item,
        distance: haversineDistance(targetLat, targetLon, pointLat, pointLon)
      }
    })
    .sort((a, b) => a.distance - b.distance)

  return pointsDistance.map(item => item.point)
}

function haversineDistance (lat1, lon1, lat2, lon2) {
  const R = 6371 // Радиус Земли в километрах
  const toRadians = degree => degree * (Math.PI / 180)

  const dLat = toRadians(lat2 - lat1)
  const dLon = toRadians(lon2 - lon1)

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2)

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))

  const distance = R * c // Расстояние в километрах
  return distance
}

